import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { IMenuElement } from 'src/app/_interfaces/menu-elements/i-menu-elements';

@Component({
  selector: 'app-dots-menu',
  templateUrl: './dots-menu.component.html',
  styleUrls: ['./dots-menu.component.scss']
})
export class DotsMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  isClicked:boolean = false;
  @Input() menuElements: IMenuElement[];
  @Output() menuItemClicked:EventEmitter<IMenuElement> = new EventEmitter();
  documentClickedSubscription: Subscription | undefined;

  constructor(@Inject(DOCUMENT) private document: Document) { }
  ngOnDestroy(): void {
    this.documentClickedSubscription?.unsubscribe();
  }
  
  @ViewChild('dotsMenu') menuElementRef:ElementRef;
  
  ngAfterViewInit(): void {
    this.documentClickedSubscription = fromEvent(this.document, 'click')
      .pipe(
        filter((event) => {
          return !this.isInside(event.target as HTMLElement)
        })
      )
      .subscribe((res) => {
        this.isClicked = false;
      });
  }

  ngOnInit(): void {
  }

  menuClicked(){
    this.isClicked = !this.isClicked
    return this.isClicked;
  }

  onItemClicked(element: IMenuElement){
    this.menuItemClicked.emit(element);
  }

  isInside(elementToCheck: HTMLElement): boolean{
    return elementToCheck === this.menuElementRef.nativeElement
      || this.menuElementRef.nativeElement.contains(elementToCheck);
  }
}
